import { useEffect, useState } from "react";
import {
  Modal,
  Typography,
  Tabs,
  DatePicker,
  Tag,
  Space,
  Button,
  message,
} from "antd";
import axios from "../../../requests/axios";
import routes from "../../../requests/routes";
import { UserInfoComponent } from "./UserInfo/UserInfo";
import classes from "./adminUsers.module.scss";
import { Wishlist } from "./Wishlist/Wishlist";
import { UserPrograms } from "./UserPrograms/UserPrograms";
import { UserBlogs } from "./UserBlogs/UserBlogs";
import { UserReviews } from "./UserReviews/UserReviews";
import { UserGallery } from "./UserGallery/UserGallery";
import TableWithExport from "../../../generic components/TableWithExport/TableWithExport";
import { usersColumns } from "./contants";
import {
  getName,
  getEmail,
  getPhone,
  getCreated,
  fmtDate,
} from "../../../generic components/TableWithExport/TableWithExport.utils.js";
const { Text } = Typography;
const { RangePicker } = DatePicker;

const UsersTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(null);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await axios.get(routes.getAllUsers);
      const list = res?.data?.users || res?.data || [];
      setData(Array.isArray(list) ? list : []);
    } catch (e) {
      console.error("Users fetch error:", e?.message);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const items = [
    {
      key: "1",
      label: "User Info",
      children: <UserInfoComponent record={current} />,
    },
    { key: "2", label: "Wishlist", children: <Wishlist record={current} /> },
    {
      key: "3",
      label: "Programs",
      children: <UserPrograms record={current} />,
    },
    { key: "4", label: "Blogs", children: <UserBlogs record={current} /> },
    { key: "5", label: "Gallery", children: <UserGallery record={current} /> },
    { key: "6", label: "Reviews", children: <UserReviews record={current} /> },
  ];

  const usersColumns = [
    { title: "#", width: 64, align: "center", render: (_v, _r, i) => i + 1 },
    {
      title: "Name",
      sorter: (a, b) => getName(a).localeCompare(getName(b)),
      render: (_, r) => <Text strong>{getName(r) || "—"}</Text>,
    },
    {
      title: "Email",
      sorter: (a, b) => getEmail(a).localeCompare(getEmail(b)),
      render: (_, r) => <Text copyable>{getEmail(r) || "—"}</Text>,
    },
    {
      title: "Phone",
      responsive: ["md"],
      render: (_, r) => getPhone(r) || "—",
    },
    {
      title: "Verified",
      width: 110,
      render: (_, r) =>
        r?.verified ? <Tag color="green">Verified</Tag> : <Tag>Unverified</Tag>,
    },
    {
      title: "Admin",
      width: 90,
      render: (_, r) =>
        r?.isAdmin ? <Tag color="blue">Admin</Tag> : <Tag>—</Tag>,
    },
    {
      title: "Created",
      width: 200,
      sorter: (a, b) =>
        new Date(getCreated(a) || 0) - new Date(getCreated(b) || 0),
      render: (_, r) => fmtDate(getCreated(r)),
    },
    {
      title: "Actions",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            onClick={() => {
              setCurrent(record);
              setOpen(true);
            }}
          >
            Show
          </Button>
          <Button
            danger
            type="link"
            onClick={() => {
              Modal.confirm({
                title: "Delete user",
                content:
                  "Are you sure you want to delete this user and all their reviews?",
                okText: "Delete",
                okType: "danger",
                cancelText: "Cancel",
                onOk: async () => {
                  try {
                    await axios.delete(routes.deleteUser(record._id));
                    message.success("User deleted");
                    await fetchUsers();
                  } catch (e) {
                    message.error("Failed to delete user");
                  }
                },
              });
            }}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className={classes.wrapper}>
      <h2 className="adminTitle">Users</h2>

      <TableWithExport
        columns={usersColumns}
        data={data}
        loading={loading}
        tableName="users"
        filters={true}
        setCurrent={setCurrent}
      />

      <Modal
        open={open}
        title={getName(current) || "User details"}
        onOk={() => setOpen(false)}
        width={720}
        okText="Done"
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Tabs defaultActiveKey="1" items={items} />
      </Modal>
    </div>
  );
};

export default UsersTable;
